import { render, staticRenderFns } from "./PlansTable.vue?vue&type=template&id=47e99b55&scoped=true&"
import script from "./PlansTable.vue?vue&type=script&lang=js&"
export * from "./PlansTable.vue?vue&type=script&lang=js&"
import style0 from "./PlansTable.vue?vue&type=style&index=0&id=47e99b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e99b55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VIcon,VRow,VSlideYTransition})
